import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import Events from './admin/Events';
import Event from './user/Event';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, useNavigate, HashRouter } from "react-router-dom";
import EventReport from './user/EventReport';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";
import Permission from './Permision';
import Callback from './Callback';
import MyEvent from './user/MyEvent';
import "./newrelic";
export const msalInstance = new PublicClientApplication(msalConfig);

//get initialize msalInstance
msalInstance.initialize();

const activeAccount = msalInstance.getActiveAccount();

if (!activeAccount) {
  // Account selection
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}

//set the account
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const authenticationResult = event.payload as AuthenticationResult;
    const account = authenticationResult.account;
    msalInstance.setActiveAccount(account);
  }
});

//enable account storage event
msalInstance.enableAccountStorageEvents();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<MyEvent />} />
        <Route path="/admin" element={<App />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event/:eventnumber" element={<Event />} />
        <Route path="/event/:eventnumber/report" element={<EventReport />} />
        <Route path="/accessdenied" element={<Permission />} />
        <Route path="/myevents" element={<MyEvent />} />
      </Routes>
    </BrowserRouter>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
